import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=76523fec&scoped=true"
import script from "./patient.vue?vue&type=script&lang=js"
export * from "./patient.vue?vue&type=script&lang=js"
import style0 from "./patient.vue?vue&type=style&index=0&id=76523fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76523fec",
  null
  
)

export default component.exports